export enum CashRegistersState {
  Active = 'Active',
  Removed = 'Removed',
  Hidden = 'Hidden',
}

export enum CashRegisterType {
  Telegram = 'Telegram',
  Coinbase = 'Coinbase',
  Paypal = 'Paypal',
  Yoomoney = 'Yoomoney',
  Yookassa = 'Yookassa',
  Prodamus = 'Prodamus',
  Robokassa = 'Robokassa',
  SberbankBusiness = 'SberbankBusiness',
  Unitpay = 'Unitpay',
  PayboxMoney = 'PayboxMoney',
  WalletPayProvider = 'WalletPay',
  Nowpayments = 'Nowpayments',
  Cryptobot = 'Cryptobot',
  Cryptocloud = 'Cryptocloud',
  StripeRegister = 'Stripe',
  Cloudpayments = 'Cloudpayments',
}

export type CashRegisterModel = {
  id: number
  name: string
  currency: string
  type: CashRegisterType
  state: CashRegistersState
  valid: boolean
}

export type Telegram = {
  token: string
  provider_type?: keyof typeof TelegramProviderType
  send_receipt?: boolean
  vat_code?: YookassaVatCode | null
  need_email: boolean
  need_name: boolean
  need_phone: boolean
  need_address: boolean
}

export const TelegramProviderType = {
  Stripe: 'Stripe',
  SmartGlocal: 'SmartGlocal',
  Unlimint: 'Unlimint',
  Tranzzo: 'Tranzzo',
  Paykassma: 'Paykassma',
  Yookassa: 'Yookassa',
  Sberbank: 'Sberbank',
  PSB: 'PSB',
  Bank131: 'Bank131',
  Payme: 'Payme',
  CLICK: 'CLICK',
  LiqPay: 'LiqPay',
  LeoGaming: 'LeoGaming',
  Cascad: 'Cascad',
  Portmone: 'Portmone',
  Paymega: 'Paymega',
  ECOMMPAY: 'ECOMMPAY',
  PayMaster: 'PayMaster',
  Robokassa: 'Robokassa',
  GlobalPayUZ: 'GlobalPayUZ',
  GlobalPayKG: 'GlobalPayKG',
  iPay88: 'iPay88',
  PayBox: 'PayBox',
  Redsys: 'Redsys',
  Freedom: 'Freedom',
  BillLine: 'BillLine',
  Chapa: 'Chapa'
} as const

export type Coinbase = {
  secret: string
}

export type Paypal = {
  secret: string
  clientId: string
}

export type Yoomoney = {
  receiver: string
  secret: string
}

export type Yookassa = {
  secret: string
  shopId: string
  add_receipt: boolean
  vat_code: YookassaVatCode | null
  default_email: string
}

export type  Prodamus = {
  login: string
  secret: string
}

export type Robokassa = {
  login: string
  pass1: string
  pass2: string
  add_receipt: boolean
  tax: RobokassaTax | null
  sno: RobokassaSno | null
}

export type SberbankBusiness = {
  user: string
  password: string
  token: string
}

export type Unitpay = {
  secret_key: string
  project_id: string
  add_receipt: boolean
  receipt_email: string | null
  receipt_nds: UnitpayReceiptNds | null
}

export type PayboxMoneyType = {
  shop_id: string
  accept_secret_key: string
}

export type WalletPayProvider = {
  key: string
}

export type Nowpayments = {
  token: string
  secret: string
}

export type Cryptobot  = {
  token: string
}

export type Cryptocloud = {
  key: string
  secret: string
  shop: string
}

export type StripeRegister = {
  token: string
  secret: string
}

export type CloudpaymentsRegister = {
  api_secret: string
  public_id: string
}

export type CashRegisterDataType = Paypal & Validation
  | Coinbase & Validation
  | Telegram & Validation
  | Yoomoney & Validation
  | Yookassa & Validation
  | Prodamus & Validation
  | Robokassa & Validation
  | SberbankBusiness & Validation
  | Unitpay & Validation
  | PayboxMoneyType & Validation
  | WalletPayProvider & Validation
  | StripeRegister & Validation
  | Cryptocloud & Validation
  | Cryptobot & Validation
  | Nowpayments & Validation
  | CloudpaymentsRegister & Validation

export type Validation = {
  validate: (target?: CreateCashRegisterModel | UpdateCashRegisterModel) => boolean
}

export type CreateCashRegisterModel = {
  name: string
  currency: string
  type: CashRegisterType
  data: CashRegisterDataType
}

export type UpdateCashRegisterModel = {
  id: number
  name: string
  currency: string
  type: CashRegisterType
  data?: CashRegisterDataType
}

export enum YookassaVatCode {
  VatCode1 = '1',
  VatCode2 = '2',
  VatCode3 = '3',
  VatCode4 = '4',
  VatCode5 = '5',
  VatCode6 = '6',
}

export enum UnitpayReceiptNds {
  none = 'none',
  vat0 = 'vat0',
  vat10 = 'vat10',
  vat20 = 'vat20',
}

export enum RobokassaTax {
  none = 'none',
  vat0 = 'vat0',
  vat10 = 'vat10',
  vat110 = 'vat110',
  vat20 = 'vat20',
  vat120 = 'vat120',
}

export enum RobokassaSno {
  osn = 'osn',
  usn_income = 'usn_income',
  usn_income_outcome = 'usn_income_outcome',
  esn = 'esn',
  patent = 'patent',
}
